import { VoucherCampaign } from '../../generated/graphql';

export function getVoucherCampaignStatus(campaign?: Partial<VoucherCampaign>): 'active' | 'inactive' | 'scheduled' {
  const startAutomation = campaign?.automations?.nodes?.find((automation) => automation.operation === 'START');

  if (campaign?.status === 'INACTIVE' && startAutomation) {
    return 'scheduled';
  }

  if (campaign?.status === 'ACTIVE') {
    return 'active';
  }

  return 'inactive';
}
